import { createTheme } from '@material-ui/core/styles';

export default userDarkMode => createTheme({
    palette: {
        type: userDarkMode ? 'dark' : 'light',
        primary: {
            main: '#007cfc',
        },
        background: {
            highlightedCard: userDarkMode ? '#6b6a64' : '#fffdee',
        },
    },
    typography: {
    },
    overrides: {
        MuiGrid: {
            container: {
                '@media print': {
                    display: 'block',
                    position: 'relative',
                },
            },
            item: {
                '@media print': {
                    display: 'block',
                    position: 'relative',
                },
            },
        },
        MuiCard: {
            root: {
                '@media print': {
                    boxShadow: 'none',
                },
            },
        },
        MuiPaper: {
            root: {
                '@media print': {
                    boxShadow: 'none !important',
                },
            },
        },
        MuiCardContent: {
            root: {
                '@media print': {
                    padding: '0 0 16px 0',
                },
            },
        },
        MuiTablePagination: {
            root: {
                '@media print': {
                    display: 'none',
                },
            },
        },
        MuiToolbar: {
            gutters: {
                '@media print': {
                    paddingLeft: 0,
                },
            },
        },
        MuiTableCell: {
            root: {
                '@media print': {
                    marginLeft: 0,
                },
            },
        },
    },
});
